<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>

    <div class="secure-block">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/internationalIndex">海外医疗</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">医疗签证</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          id="one">如何办理医疗签证</h3>
      <h4 class="rescue-title">日本医疗签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        日本医疗居留签证，是签发给以在日本接受治疗（包括精密体检等）为目的赴日的外国人患者以及同行人员的签证。申请医疗居留签证需要由日本外务省备案的身份担保机构提供身份担保。<br/> 自2011年日本外务省创设医疗居留签证制度之后，日本威马捷救援株式会社于同年2月取得医疗居留签证身份担保机构资质。
        <br/><br/> 日本外务省官网医疗居留签证身份担保机构一览
        <a href="https://www.mofa.go.jp/j_info/visit/visa/medical_stay2.html">https://www.mofa.go.jp/j_info/visit/visa/medical_stay2.html</a>
      </p>
      <p class="more-case">申请日本医疗居留签证所需文件</p>
      <div class="container-img-text">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">护照</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">签证申请书（由中国国内签证代理机构提供）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">照片</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">证明具有一定经济能力的材料（银行余额证明书等）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">户口簿复印件</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">暂住证（只限于户口不属于当地管辖区内的申请）</span>
            </li>
          </ul>
          <p class="secure-note-title">2. 需要威马捷准备的文件</p>
          <ul class="customer-list">
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">“医疗机构发行的受诊等预定证明书及身份担保机构发行的身份担保机构”</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">“治疗预定表”（根据治疗内容，需多次赴日治疗时）</span>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country1.jpeg"
             alt="">
      </div>
      <p class="more-case">日本大使馆、各总领事馆、办事处管辖地区</p>
      <div class="text-con-box">
        <div class="box">
          <div class="left left-first">日本驻华大使馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.cn.emb-japan.go.jp/index.htm">http://www.cn.emb-japan.go.jp/index.htm</a></p>
            <p>北京市、天津市、陕西省、山西省、甘肃省、河南省、河北省、 湖北省、 湖南省、青海省、新疆、宁夏、西藏、内蒙古
            </p>
            <p class="sign">*威马捷可代理送签日本驻华大使馆管辖地区的申请</p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻上海总领事馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.shanghai.cn.emb-japan.go.jp/itprtop_zh/index.html">http://www.shanghai.cn.emb-japan.go
              .jp/itprtop_zh/index.html</a></p>
            <p>上海市、安徽省、浙江省、江苏省、江西省
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻广州总领事馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.guangzhou.cn.emb-japan.go.jp/itprtop_zh/index.html">http://www.guangzhou.cn.emb-japan.go
              .jp/itprtop_zh/index.html</a></p>
            <p>广东省、海南省、福建省、广西壮族自治区
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻沈阳总领事馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.shenyang.cn.emb-japan.go.jp/cn/">http://www.shenyang.cn.emb-japan.go.jp/cn/</a></p>
            <p>辽宁省（除大连市）、吉林省、黑龙江省
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻重庆总领事馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.chongqing.cn.emb-japan.go.jp/itprtop_zh/index.html">http://www.chongqing.cn.emb-japan.go
              .jp/itprtop_zh/index.html</a></p>
            <p>重庆市、四川省、贵州省、云南省
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本常驻大连领事办公室</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.dalian.cn.emb-japan.go.jp/itprtop_zh/index.html">http://www.dalian.cn.emb-japan.go
              .jp/itprtop_zh/index.html</a></p>
            <p>大连市
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻青岛总领事馆</div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.qingdao.cn.emb-japan.go.jp/itprtop_zh/index.html">http://www.qingdao.cn.emb-japan.go
              .jp/itprtop_zh/index.html</a></p>
            <p>山东省
            </p>
          </div>
        </div>
        <div class="box">
          <div class="left">日本驻香港总领事馆 </div>
          <div class="rigth">
            <p><a target="_blank" href="http://www.hk.emb-japan.go.jp/chi/index.html">http://www.hk.emb-japan.go.jp/chi/index.html</a></p>
            <p>香港特别行政区、澳门特别行政区
            </p>
          </div>
        </div>
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:27px;"
          id="two">德国就诊医疗签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        和德国医疗组织取得了预约的申请人可以申请就诊医疗签证。此签证适用于随行家庭成员。重要的是需要提交由医院或医师出具的包括逗留时长和预估费用的确认信，并证明有能力承担所有费用。
      </p>
      <p class="more-case">申请德国就诊医疗签证所需文件</p>
      <div class="container-img-text"
           style="margin-bottom:0;">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">护照原件</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">两张照片</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">在线填写短期申根签证申请表（原件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text" style="width: 100%;">以下文件（复印件）：</span>
              <i>- 护照信息页及签名页复印件</i>
              <i>- 过往申根签证的复印件</i>
              <i>- 户口本复印件（仅适用于中国公民）</i>
              <i>- 在中国的有效居留许可证（仅适用于外国人）</i>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">旅行医疗保险 （原件+复印件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">住宿证明（复印件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">申请人的银行账户对账单 （原件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">工作单位/自营企业开具的在职证明（原件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">工作单位/自营企业营业执照 （复印件）</span>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country2.jpg"
             alt="">
      </div>
      <ul class="customer-list bottom-customer-list">
        <li>
          <span class="icon">•</span>
          <span class="text">关于目前职业状况的解释信 （原件）</span>
          <i>
            - 自由职业者：作为代替企业或雇主开具的在职证明的材料，自由职业者的解释信应详细阐述目前从事的自由职业并说明收入情况（可提供相应证明材料）。解释信用中文书写，附上德文或英文翻译。

          </i>
          <i>- 无业人员：作为代替工作单位/雇主开具的在职证明的材料，解释信应详细说明个人情况，收入来源和旅行费用的承担用中文书写，并附德文或英文翻译。
          </i>
        </li>
        <li style="display: flex;">
          <span class="icon">•</span>
          <span class="text">若申请人本人无足够的资金，须提供经济来源为其配偶的证明</span>
        </li>
        <li style="display: flex;">
          <span class="icon">•</span>
          <span class="text">在读证明 （原件）</span>
        </li>
        <li>
          <span class="icon">•</span>
          <span class="text">未成年人</span>
          <i>- 学生证 （复印件）</i>
          <i>- 未成年申请者的出生医学证明或与其父母的亲属关系证明 （原件+复印件）</i>
          <i>- 父母的出行同意声明</i>
          <i>- 经济来源证明</i>
        </li>
        <li>
          <span class="icon">•</span>
          <span class="text">退休人员</span>
          <i>- 退休证复印件</i>
        </li>
        <li>
          <span class="icon">•</span>
          <span class="text">委托代理人递交签证申请/领取护照的委托书（原件）</span>
          <i>- 如您选择由他人代交您的签证申请，须提供此项材料</i>
        </li>
        <li>
          <span class="icon">•</span>
          <span class="text">代理人身份证或护照 （原件+复印件）</span>
          <i>- 如您选择由他人代交您的签证申请，须提供此项材料</i>
        </li>
        <li style="display: flex;">
          <span class="icon">•</span>
          <span class="text">申请人希望提交的补充材料</span>
        </li>
      </ul>
      <div class="secure-note">
        <p class="secure-note-title">2. 需要威马捷准备的文件</p>
        <ul class="customer-list bottom-customer-list">
          <li style="display: flex;">
            <span class="icon">•</span>
            <span class="text">德国医院/医生的确认函（原件）</span>
          </li>
          <li style="display: flex;">
            <span class="icon">•</span>
            <span class="text">医疗费用的承担证明（原件）</span>
          </li>
        </ul>
      </div>
      <h4 class="rescue-title"
          style="margin-top:39px;margin-top:39px;"
          id="four">新加坡旅游签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        赴新加坡就医，需办理旅游签证入境新加坡。入境新加坡后，经医院检查诊断，需要继续治疗的医院可出具证明办理签证延期手续。
      </p>
      <p class="more-case">申请新加坡旅游签证所需文件</p>
      <div class="container-img-text">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">护照：护照原件及护照照片页复印件</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">Form 14A 签证申请表格（原件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">彩色照片：二张</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">中国身份证：原件及复印件</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">签证费</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">申请签证需提供其他材料如下</span>
              <i style="width:393px;">- 在职证明。申请人若无工作，则必须提供证明其个人经济状况的文件， 如银行存款证明 (原件及复印件)。
              </i>
              <i>- 户口簿：申请者户口簿 (全本，每页：原件及复印件) 。</i>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">领事馆要求提供的其他材料</span>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country3.jpg"
             alt="">
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:27px;margin-top:39px;"
          id="six">美国商务旅游签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        希望赴美治疗患者，需要申请美国B-1/B-2签证。B-1/B-2商务旅游签证主要面向短期商务旅行(B-1)或旅游观光/寻求医疗服务(B-2)的申请人。B-1和B-2签证通常会合二为一，作为一类签证颁发： B-1/B-2。
      </p>
      <p class="more-case">申请美国就诊医疗签证所需文件</p>
      <div class="container-img-text"
           style="margin-bottom:0;">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">非移民签证电子申请表(DS-160)：在线申请。</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">有效护照</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">照片一张（最近六个月内拍摄的2英寸x2英寸）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">请在面谈时携带下列材料（最好使用原件）</span>
              <i style="width:393px;">- 当前收入证明、纳税单、房产证或企业产权证、资产证明。</i>
              <i>- 行程表和/或其他有关旅行计划的说明。</i>
              <i style="width:393px;">- 申请人所在单位的介绍信，详细说明申请人的职位、工资、入职时间、 是否获准休假、赴美参加商务活动的目的（如有）等。
              </i>
              <i style="width:393px;">- 犯罪/法庭记录（无论在何地被捕或定罪，即使已服完刑期或被赦免也不例外）</i>
              <i>- 医疗材料：</i>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country4.jpg"
             alt="">
      </div>
      <div class="secure-note secure-note-long">
        <i style="color: #333130;">中国本地医师的医疗诊断书，说明申请人的病情和赴美治疗的理由。</i>
        <i style="color: #333130;">如果由个人或组织为申请人支付旅费、治疗费和生活费，则应出具相应的资金证明。如果上述费用的支付担保人为个人，则需提供相关的银行凭证或收入/存款证明或所得税申报表的核证副本，以此来证明其财力。</i>
        <p class="secure-note-title">2. 需要威马捷准备的文件</p>
        <ul class="customer-list bottom-customer-list" style="width: 915px;">
          <li style="display: flex;">
            <span class="icon">•</span>
            <span class="text">美国医师或医疗机构出具的信函，表明其愿意为申请人提供治疗服务并详述预期疗程和治疗费用（包括诊费、住院费以及所有医疗相关开销）。</span>
          </li>
        </ul>
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:27px;margin-top:39px;"
          id="five">意大利就诊医疗签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        和意大利医疗组织取得了预约的申请人可以申请就诊医疗签证。医疗签证必须递交意大利医疗机构签发的诊断书、治疗周期、诊疗费用、以及收取30%诊疗费的收据。
      </p>
      <p class="more-case">申请意大利就诊医疗签证所需文件</p>
      <div class="container-img-text"
           style="margin-bottom:0;">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">申根签证申请表（原件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">一张照片（白色背景、35*40mm、6个月内照片）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">有效护照（原件+两份复印件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">往返机票预订单（复印件）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">医疗/健康证明如下：</span>
              <i>由中国医院出具的病人疾病/疾病状况的医疗证明，需翻译成英文。</i>
            </li>
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">在意大利足够的财力支付证明，涵盖所有医疗费用、健康卫生机构以外 的生活和住宿费用、同时覆盖病人转移和帮佣转移的费用。
              </span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">保险（原件及复印件）</span>
              <i>- 保险必须覆盖申根地区。</i>
              <i>- 保额至少为3万欧元并包含医疗费用、遣返费用。</i>
              <i>- 其有效期必须包括所有在申根地区的停留时间。</i>
            </li>
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">签证申请/护照返还授权书（如果申请人本人无法亲自递交申请）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">附加说明：选择性文件。</span>
            </li>
          </ul>
          <p class="secure-note-title">2. 需要威马捷准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">意大利医院/医生的声明函</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">意大利医院出具的诊疗费收款证明 </span>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country5.jpg"
             alt="">
      </div>
      <h4 class="rescue-title"
          style="margin-bottom:27px;margin-top:39px;"
          id="cases">瑞士就诊医疗签证</h4>
      <p class="para"
         style="margin-bottom:39px;">
        赴瑞士和瑞士医疗组织取得了预约的申请人可以申请就诊医疗签证。
      </p>
      <p class="more-case">申请瑞士就诊医疗签证所需文件</p>
      <div class="container-img-text"
           style="margin-bottom:0;">
        <div class="secure-note">
          <p>根据签证代办机构不同所需资料有所不同，以下信息仅供参考。</p>
          <p class="secure-note-title">1. 需要申请人准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">签证申请表：填写完整并由申请人签字。</span>
            </li>
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">2张照片（3.5 cm x 4.5 cm，没有损坏的白底或浅底彩色近照）</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">护照</span>
            </li>
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">医疗保险：保额至少3万欧元，须覆盖在申根区的整个停留时间。</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">往返中国的飞机票订单</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">住宿证明：住宿证明需覆盖申根区整个停留时间。
              </span>
            </li>
            <li style="display: flex;">
              <span class="icon">•</span>
              <span class="text">所有证明旅行计划的材料（酒店或机票订单，交通，行程单等）
              </span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">申请人经济证明：银行最近三个月的进出账单（定期存款除外）</span>
              <i>- 在职人员</i>
              <i class="ladder2">所在单位营业执照复印件，需加盖公章</i>
              <i class="ladder2">以单位抬头纸出具的证明信（英文，或中文带英文翻译），加盖公章签名及日期，明确标出：</i>
              <i class="ladder3">单位地址，电话及传真；</i>
              <i class="ladder3">签署人姓名及职务；</i>
              <i class="ladder3">申请者职务，月薪，雇佣年限；</i>
              <i class="ladder3">请假许可；</i>
              <i>- 退休人员</i>
              <i class="ladder2">退休金或其他固定收入的证明</i>
              <i>- 无业成年人</i>
              <i class="ladder2">如已婚，提供配偶的工作及收入证明和外交部认证的结婚公证书。</i>
              <i class="ladder2">如未婚/离异/丧偶，请提供其他固定收入证明。</i>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">未成年人（18岁以下）</span>
              <i>- 学生证和学习证明原件需明确标出以下信息：</i>
              <i class="ladder2">学校地址，联系电话</i>
              <i class="ladder2">请假许可</i>
              <i class="ladder2">批准人的职位</i>
              <i>- 经过中国外交部或中国驻外使馆认证的亲属关系或法定监护关系公证书</i>
              <i>- 如未成年人单独旅行或跟随父母其中一方旅行还需提供：</i>
              <i class="ladder2">经过中国外交部或中国驻外使馆认证的亲属或法定监护人许可公证书</i>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">户口薄 （无需翻译）：所有信息页的复印件</span>
            </li>
            <li>
              <span class="icon">•</span>
              <span class="text">复印件：</span>
              <i>- 护照首页及签字页复印件</i>
              <i>- 已有的申根签证</i>
              <i>- 居留证（仅限外国人）</i>
            </li>
          </ul>
          <p class="secure-note-title">2. 需要威马捷准备的文件</p>
          <ul class="customer-list">
            <li>
              <span class="icon">•</span>
              <span class="text">瑞士医疗诊所或医生的邀请信</span>
            </li>
          </ul>
        </div>
        <img class="left-pic"
             src="../assets/images/medicine/country7.jpg"
             alt="">
      </div>
    </div>
    <div class="body-gray">
      <div class="body">
        <div class="title clearfix">
          <span class="title-name name1">友情链接</span>
          <span class="title-english title-gray">LINKS</span>
          <span class="title-note title-gray">友情链接</span>
          <div class="title-line"></div>
        </div>
        <div class="link-content" style="position: relative;z-index: 101;">
          <a class="link-cell cell1"
             target="_blank"
             href="https://www.cn.emb-japan.go.jp/itprtop_zh/index.html">
            <div class="link-text link1">日本国驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell2"
             target="_blank"
             href="https://china.diplo.de/cn-zh">
            <div class="link-text link2">德国驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="https://www.mfa.gov.sg/Overseas-Mission/Beijing/CN/Beijing-CN">
            <div class="link-text link3">新加坡驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell1"
             target="_blank"
             href="https://china.usembassy-china.org.cn/zh/education-culture-zh/beijing-american-center-zh/">
            <div class="link-text link1">美国驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell2"
             target="_blank"
             href="https://ambpechino.esteri.it/ambasciata_pechino/zh/">
            <div class="link-text link2">意大利驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
          <a class="link-cell cell3"
             target="_blank"
             href="https://www.eda.admin.ch/countries/china/zh/home/representations/botschaft.html">
            <div class="link-text link3">瑞士驻华大使馆</div>
            <div class="link-text-shadow"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reason1 from "@/assets/images/medicine/reason11.png"
import reason2 from "@/assets/images/medicine/reason12.png"
// import reason3 from "@/assets/images/medicine/reason13.png"
// import reason4 from "@/assets/images/medicine/reason14.png"
import reason5 from "@/assets/images/medicine/reason18.png"
import reason6 from "@/assets/images/medicine/reason19.png"
import map from "@/assets/images/home/icon-link1.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      reason1,
      reason2,
      // reason3,
      // reason4,
      reason5,
      reason6,
      map,
      countries: [],
      cases: [],
      hospitals: [],
      anchor: [
        { title: '日本医疗签证', id: 'one' },
        { title: '德国就诊医疗签证', id: 'two' },
        { title: '新加坡旅游签证', id: 'four' },
        { title: '美国商务旅游签证', id: 'six' },
        { title: '意大利就诊医疗签证', id: 'five' },
        { title: '瑞士就诊医疗签证', id: 'cases' },
      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 4,
          //抗衰老 6
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          // console.log(res.data.data)
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          id: 0
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style lang="less" scoped>
//banner 轮播
.body-white {
  background: #fff;
}
.body-gray {
  background: #f4f4f4;
}
.body {
  width: 970px;
  overflow: hidden;
  margin: 0 auto;
}
.link-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 80px;
  .link-cell {
    position: relative;
    width: 306px;
    height: 110px;
    background: #fff;
    border: 1px solid #d6d6d6;
    margin-bottom: 34px;
    // transition: 0.5s linear;
    .link-text {
      position: absolute;
      right: 0;
      top: 20px;
      z-index: 3;
      width: 194px;
      height: 50px;
      font-size: 22px;
      color: #fff;
      line-height: 50px;
      text-align: center;
      transition: 0.3s linear;
    }
    .link-text-shadow {
      position: absolute;
      right: 0;
      top: 32px;
      z-index: 1;
      display: block;
      width: 206px;
      height: 50px;
      background: #d8d8d8;
    }
    .link1 {
      background: #ae1e10;
    }
    .link2 {
      background: #3c4c7e;
    }
    .link3 {
      background: #585858;
    }
    .link4 {
      background: #7c6f41;
    }
  }
  .link-cell:hover .link-text {
    width: 206px;
    transform: translateY(14px);
    transform-origin: right bottom;
    transition: 0.3s linear;
  }
  .cell1 {
    background: #fff url('../assets/images/home/icon-link1.png') no-repeat 20px
      22px;
  }
  .cell2 {
    background: #fff url('../assets/images/home/icon-link2.png') no-repeat 20px
      22px;
  }
  .cell3 {
    background: #fff url('../assets/images/home/icon-link3.png') no-repeat 20px
      22px;
  }
}
.left-pic {
  width: 441px;
  height: 310px;
}
.customer-list {
  // margin-bottom: 0;
  // padding-left: 0;
  width: 100%;
  li {
    // list-style-type: disc;
    // list-style-position: inside;
    font-size: 16px;
    color: #333130;
    line-height: 32px;
    display: table;
    width: 100%;
    padding-right: 30px;
    box-sizing: border-box;
    span {
      display: block;
      float: left;
    }
    .icon {
      width: 21px;
      text-align: left;
      font-size: 40px;
      margin-left: 0px;
      margin-right: 10px;
    }
    .text {
      /*width: 411px !important;*/
      font-size: 16px;
      margin-left: 2px;
    }

    i {
      margin-left: 50px;
      display: block;
      font-style: normal;
    }
    .ladder2 {
      margin-left: 80px;
    }
    .ladder3 {
      margin-left: 110px;
    }
  }
}
.bottom-customer-list {
  li {
    width: 560px;
    .text {
      width: 100% !important;
    }
  }
}
.para {
  font-size: 16px;
  color: #333130;
  line-height: 32px;
  a {
    color: #333130;
    text-decoration: underline;
  }
}
.more-case {
  font-size: 20px !important;
  padding-left: 11px !important;
  margin: 0;
  margin-bottom: 14px;

  &::before {
    width: 4px !important;
    height: 20px !important;
    top: 5px !important;
    background: #ae1e10;
  }
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 0 30px 30px 30px;
  margin: 20px auto 50px;
}
.secure-title {
  font-size: 24px;
  color: #000;
  line-height: 28px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 45px;
  a {
    float: right;
    // font-size: 14px;
    color: #333130;
  }
}
.title01 {
  // background-image: url('../assets/images/home/yy-icon.png');
  padding-top: 107px;
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
}
.title02 {
  background-image: url('../assets/images/home/fwal-icon.png');
  background-position: 0 70px;
  background-size: 28px 28px;
}
.secure-reason {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
.secure-note {
  font-size: 16px;
  color: #000;
  width: 591px;
  line-height: 32px;
  .secure-note-title {
    margin-top: 25px;
  }
}
.secure-note-long {
  i {
    font-style: normal;
    margin-left: 60px;
    display: block;
    width: 844px;
  }
}
.secure-specials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 72px;
  p {
    width: 234px;
    height: 65px;
    background: #ae1e10;
    color: #fff;
    font-size: 24px;
    line-height: 65px;
    text-align: center;
  }
}
.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin-bottom: 25px;
  }
  .hospital-name {
    min-height: 47px;
    font-size: 18px;
    color: #333130;
    line-height: 24px;
    margin-bottom: 15px;
    padding: 0 10px;
  }
  .hospital-info {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    color: #9b9898;
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px;
  }
}
.qualify {
  padding: 50px 0 60px;
}
.qualify-title {
  font-size: 24px;
  color: #000;
  text-align: center;
  margin: 40px 0;
}
.secure-zizhi {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 66px;
  .qualifications {
    img {
      width: 163px;
      height: 226px;
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      color: #ae1e10;
      line-height: 20px;
      text-align: center;
    }
  }
}
.user-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .secure-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 110px;
    border: 1px solid #dcdcdc;
    background: #fff;
    img {
      width: 60px;
      height: 60px;
      margin-right: 18px;
    }
    p {
      font-size: 28px;
      color: #ae1e10;
    }
  }
}
.group-list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  li {
    width: 300px;
    list-style: disc;
    list-style-position: inside;
    color: #333;
    font-size: 16px;
    line-height: 30px;
    text-decoration: none;
    text-indent: 50px;
  }
}
.special-title {
  position: relative;
  background: #e9ebf4;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  padding-left: 93px;
  overflow: hidden;
  margin-bottom: 40px;
  color: #333333;
  font-weight: normal;
  span {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 84px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
  }
}
.medicine-case {
  width: 100%;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  // margin-bottom: 10px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }
  .case-info {
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;
      p {
        display: inline-block;
        font-size: 16px;
      }
    }
    .case-ill {
      font-size: 18px;
      color: #cf1300;
      line-height: 22px;
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }
    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.container-img-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.container-img-text img {
  width: 441px;
  height: 310px;
  margin-top: 70px;
}
.medicine-case .case-info .case-ill .b {
  color: #333;
}
.text-con-box {
  // padding:
  margin-bottom: 80px;
  .box {
    padding: 20px 20px;
    font-size: 16px;
    color: #333130;
    display: table;
    box-sizing: border-box;
    background: #e9ebf4;
    margin-top: 6px;
  }
  .left {
    float: left;
    width: 208px;
    line-height: 60px;
  }
  .left-first {
    line-height: 126px;
  }
  .rigth {
    float: left;
    width: 668px;
    line-height: 32px;
    .sign {
      color: #ae1e10;
    }
  }
}

@media screen and (min--moz-device-pixel-ratio: 0) {
  .customer-list li .text {
    width: 440px !important;
  }
}
_:-moz-tree-row(hover),
.customer-list li .text {
  width: 440px !important;
}
@media screen and (min--moz-device-pixel-ratio: 0) {
  .bottom-customer-list {
    li {
      width: 918px;
      .text {
        width: 855px !important;
      }
    }
  }
}
_:-moz-tree-row(hover),
.bottom-customer-list {
  li {
    width: 918px;
    .text {
      width: 855px !important;
    }
  }
}
</style>
